(() => {
  const productCopy = {
    eroslim: 'Schmale Bauform mit sichtbarer Abdeckung für begehbare Terrassen.',
    eroslot: 'Eine zurückhaltende Linienentwässerung für hochwertige Terrassen- und Gartenflächen.',
    erostable: 'Für begehbare Randbereiche mit verschiedenen Breiten und Aufbauhöhen.',
    eroplain: 'Flexible Drainage für Belagsaufbauten und begehbare Fassadenbereiche.'
  };

  const productMap = {
    'terrasse-sichtbar': 'eroslim',
    'terrasse-dezent': 'eroslot',
    'einfahrt-sichtbar': 'erostable',
    'fassade-sichtbar': 'eroplain',
    'weg-sichtbar': 'eroslim',
    'weg-dezent': 'eroslot'
  };

  const initHeader = (root) => {
    if (root.dataset.headerInitialized === 'true') return;
    root.dataset.headerInitialized = 'true';
    const button = root.querySelector('[data-menu-button]');
    const menu = root.querySelector('[data-mobile-menu]');
    if (!button || !menu) return;

    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });

    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        button.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      });
    });

  };

  const initFinder = (root) => {
    if (root.dataset.finderInitialized === 'true') return;
    root.dataset.finderInitialized = 'true';
    const form = root.querySelector('[data-finder-form]');
    const result = root.querySelector('[data-finder-result]');
    const title = root.querySelector('[data-result-title]');
    const copy = root.querySelector('[data-result-copy]');
    const link = root.querySelector('[data-result-link]');
    if (!form || !result || !title || !copy || !link) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(form);
      const place = data.get('place');
      const load = data.get('load');
      const look = data.get('look');
      const needsAdvice = load === 'befahrbar' || (place === 'einfahrt' && look === 'dezent') || (place === 'fassade' && look === 'dezent');

      if (needsAdvice) {
        title.textContent = root.dataset.adviceTitle;
        copy.textContent = root.dataset.adviceCopy;
        link.href = root.dataset.adviceUrl;
        link.textContent = root.dataset.adviceLabel;
      } else {
        const key = productMap[`${place}-${look}`] || 'eroslim';
        title.textContent = root.dataset[`${key}Title`];
        copy.textContent = productCopy[key];
        link.href = root.dataset[`${key}Url`];
        link.textContent = root.dataset.productLabel;
      }

      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-em-header]').forEach(initHeader);
    scope.querySelectorAll('[data-em-finder]').forEach(initFinder);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
